/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/Pagination'
import Shimmer from '../../../../components/Shimmer/itemShimmer'
import { dataService } from '../../../../services/data.services'
import { GetBranchId } from '../../../../CommonMethods/GetBranchId'
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate'

const GatewayTransactionTable = ({ searchParams, setSearchParams, classes, sections, startDate, endDate }) => {
    const navigate = useNavigate()
    const [transactions, setTransactions] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [loading, setLoading] = useState(true)

    const getTransactions = useCallback(async () => {
        // Map selected class/section names to their ids, same as the Collection tab.
        const className = classes?.find((item) => item.name === searchParams?.get('class_'))
        const class_id = className?._id ? className?._id : ''
        const sectionName = sections?.find((item) => item.name === searchParams?.get('section_'))
        const section_id = sectionName?._id ? sectionName?._id : ''
        try {
            setLoading(true)
            const branch_id = await GetBranchId()
            const endpoint = `parent-payments?branch_id=${branch_id}&page_number=${
                searchParams?.get('page_number') === null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ? '' : `&search=${encodeURIComponent(searchParams?.get('search'))}`}${`&filter=true${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` : `&end_date=${searchParams?.get('end_date')}`}`}${classes?.length > 0 && sections?.length > 0 ? `${
                searchParams?.get('class_') === null ? '' : `&class_id=${class_id}`}${
                searchParams?.get('section_') === null ? '' : `&section_id=${section_id}`}` : ''}${
                searchParams?.get('sort') === null ? '' : `&sort=${encodeURIComponent(searchParams.get('sort'))}`}`
            const res = await dataService.GetAPI(endpoint)
            setTransactions(res?.data?.data?.data || [])
            setTotalCount(res?.data?.data?.total_count || 0)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [startDate, endDate, classes, sections, searchParams])

    useEffect(() => {
        if (startDate != null && endDate != null) {
            getTransactions()
        }
    }, [getTransactions, startDate, endDate])

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const sortValue = searchParams.get('sort') || ''
    const handleSort = (key) => {
        const params = Object.fromEntries(searchParams)
        if (sortValue === '') params.sort = `${key}+asc`
        else if (sortValue.includes(key)) params.sort = `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`
        else params.sort = `${key}+asc`
        setSearchParams(params)
    }

    if (loading) {
        return <div className='pt-[32px]'><Shimmer /></div>
    }

    return (
        <div class="">
            <div class="-mx-1">
                <div className='text-center absolute w-full'>Collection Date from <span className="font-semibold">{searchParams?.get('start_date') === null ? formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ? formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
                <div class={`flex overflow-hidden scroll-bar px-1 topHeading ${transactions?.length < 8 ? 'pb-[62px]' : 'pb-[6px]'}`} id="search-result">
                    <table aria-label="Gateway Transactions" class="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[11%]" onClick={() => handleSort('received_date')}>
                                    <span>Received Date
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={sortValue?.split("+")[0] === "received_date" ? sortValue?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon" />
                                        </button>
                                    </span>
                                </th>
                                <th class="w-[18%]" onClick={() => handleSort('student_name')}>
                                    <span>Student Name
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={sortValue?.split("+")[0] === "student_name" ? sortValue?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon" />
                                        </button>
                                    </span>
                                </th>
                                <th class="w-[11%]"><span>Class, Section</span></th>
                                <th class="w-[15%]"><span>Gateway Transaction ID</span></th>
                                <th class="w-[9%]"><span>Status</span></th>
                                <th class="w-[14%]"><span>Failure Reason</span></th>
                                <th class="w-[10%]" onClick={() => handleSort('receipt_number')}>
                                    <span>Receipt #
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={sortValue?.split("+")[0] === "receipt_number" ? sortValue?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon" />
                                        </button>
                                    </span>
                                </th>
                                <th class="w-[12%]"><span class="flex items-center justify-end">Collection Amount</span></th>
                            </tr>
                            <tr aria-colspan="8" class="h-1"></tr>
                        </thead>
                        <tbody>
                            {transactions?.map((txn, index) => (
                                <React.Fragment key={txn.transaction_id || index}>
                                    <tr id="list-items" aria-colspan="8" class="relative h-0.5 z-[-10]"></tr>
                                    <tr
                                        class={`group ${txn.collect_fee_header_id ? 'cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (!txn.collect_fee_header_id) return
                                            navigate(`/student-master/fee-collection/fee-collection-details/${encodeURIComponent(txn.collect_fee_header_id)}`)
                                        }}
                                    >
                                        <td class="text-start">{txn.received_date ? formatAdjustedDate(txn.received_date) : '-'}</td>
                                        <td class="text-start">{txn.student_name ? `${txn.student_name} [${txn.student_id}]` : '-'}</td>
                                        <td class="text-start">{txn.class_name ? `${txn.class_name}, ${txn.section_name}` : '-'}</td>
                                        <td class="text-start break-all">{txn.gateway_payment_id || '-'}</td>
                                        <td class={`text-start capitalize ${txn.status === 'failed' ? 'text-[#E5484D]' : ''}`}>{txn.status ? txn.status.replaceAll('_', ' ') : '-'}</td>
                                        <td class={`text-start ${txn.failure_reason ? 'text-[#E5484D]' : ''}`}>{txn.failure_reason || '-'}</td>
                                        <td class="text-start capitalize">{txn.receipt_number || '-'}</td>
                                        <td class="text-end">{txn.collection_amount !== undefined && txn.collection_amount !== null ? parseFloat(txn.collection_amount).toFixed(2) : '-'}</td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                        {transactions?.length === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colSpan="8" className="no-records-message" id='no-matching-result'>
                                        {'No records found'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
                {totalCount > 10 && <Pagination
                    TotalCount={totalCount}
                    totalPageNumber={Math?.ceil(totalCount / 10)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
        </div>
    )
}
export default GatewayTransactionTable
